import { MoreOutlined, PlusOutlined, UpOutlined } from "@ant-design/icons";
import {
  IBriefInfluencerSearchRequestV2,
  IBriefInfluencerV2,
  IFieldConfig,
} from "@shared/lib/types/briefInfluencerV2";
import { Button, Divider, Dropdown, Modal, Row, Space, Spin } from "antd";

import { useEffect, useState } from "react";

import { ToastService } from "@shared/lib/services";

import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";

import useBulkActions from "@entities/brief/lib/hooks/useBulkActions";
import SuggestInfluencerPricingForm from "@entities/brief/ui/SuggetInfluencerPricing";
import { AddCustomFieldsDataButton } from "@features/AddCustomFieldsDataButton";
import { AddToCampaignFromBrief } from "@features/AddtoCampaignFromBrief";
import { AssignPricingModalV2 } from "@features/assignPricingModal/AssignPricingModalV2";
import { BriefNotificationActionType } from "@shared/lib/types/brief";
import SuggestCampaignFromBriefForm from "@shared/ui/InfluencerTable/SuggestCampaignFromBriefForm";
import AddToBucket from "@shared/ui/Modals/AddToBucket";

export function BriefPurchasedActions({
  selectedRowKeys,
  setSelectedRowKeys,
  selectedRows,
  setSelectedRows,
  refetch,
  params,
  updateBriefInfluencers,
  visibleCustomFields,
  selectAll,
  uncheckList,
  setSelectAll,
  setUncheckList,
  totalCount,
  briefInfluencers,
}: {
  selectedRowKeys: React.Key[];
  setSelectedRowKeys: React.Dispatch<React.SetStateAction<React.Key[]>>;
  selectedRows: IBriefInfluencerV2[];
  setSelectedRows: React.Dispatch<React.SetStateAction<IBriefInfluencerV2[]>>;

  refetch?: () => void;
  params?: IBriefInfluencerSearchRequestV2;
  updateBriefInfluencers: (
    data: { id: string; briefInfluencer: IBriefInfluencerV2 }[]
  ) => void;
  visibleCustomFields: IFieldConfig[];
  selectAll?: boolean;
  uncheckList?: string[];
  setSelectAll?: (val: boolean) => void;
  setUncheckList?: (val: string[]) => void;
  totalCount?: number;
  briefInfluencers?: IBriefInfluencerV2[];
}) {
  const { briefId } = useBriefStore();
  const [isSuggestModalOpen, setSuggestModalOpen] = useState<boolean>(false);
  const [
    isSuggestInfluencerPricingModalOpen,
    setIsSuggestInfluencerPricingModalOpen,
  ] = useState<boolean>(false);
  const [openAddToCampaignProps, setOpenAddToCampaignProps] = useState<{
    open: boolean;
  }>({
    open: false,
  });

  const isReAssginOrRemoveVisible = selectAll || selectedRowKeys.length > 0;

  const [bucketId, setselectedbuckedId] = useState<string>("");
  const [isBucketModalVisible, setBucketModalVissible] =
    useState<boolean>(false);

  const [pricingPocModalProps, setPricingPocModalProps] = useState<{
    visible: boolean;
    briefInfluencerId: string[];
    type: "assign" | "reassign" | "remove";
  }>({
    visible: false,
    briefInfluencerId: [],
    type: "assign",
  });

  const openPricingPocModal = (
    briefInfluencerId: string[] | string,
    type: "assign" | "reassign" | "remove"
  ) => {
    setPricingPocModalProps({
      visible: true,
      briefInfluencerId: Array.isArray(briefInfluencerId)
        ? briefInfluencerId
        : [briefInfluencerId],
      type,
    });
  };

  const {
    bulkActions,
    isBulkActions,
    isBulkActionsSuccess,
    bulkActionsError,
  } = useBulkActions();

  useEffect(() => {
    if (isBulkActionsSuccess) {
      ToastService.success("Action completed successfully");
      setBucketModalVissible(false);
      setPricingPocModalProps({
        visible: false,
        briefInfluencerId: [],
        type: "assign",
      });
      setSelectedRowKeys([]);
      setSelectedRows([]);
      setSelectAll?.(false);
      setUncheckList?.([]);
      refetch?.();
    } else if (bulkActionsError) {
      ToastService.error(bulkActionsError?.message);
    }
  }, [isBulkActionsSuccess, bulkActionsError]);

  const handleAdd = (bucketId: string) => {
    bulkActions({
      briefId,
      actionType: BriefNotificationActionType.addInfluencersToBucket,
      ids: selectedRowKeys as string[],
      notIncludeIds: uncheckList || [],
      isSelectAll: selectAll,
      filterParams: params || {},
      actionParams: {
        addInfluencersToBucketParams: {
          bucketId,
        },
      },
    });
  };

  const handleResendConfirmation = () => {
    bulkActions({
      briefId,
      actionType: BriefNotificationActionType.resendConfirmation,
      ids: selectedRowKeys as string[],
      notIncludeIds: uncheckList || [],
      isSelectAll: selectAll,
      filterParams: params || {},
      actionParams: {},
    });
  };

  const handleSkipConfirmation = () => {
    bulkActions({
      briefId,
      actionType: BriefNotificationActionType.skipConfirmation,
      ids: selectedRowKeys as string[],
      notIncludeIds: uncheckList || [],
      isSelectAll: selectAll,
      filterParams: params || {},
      actionParams: {},
    });
  };

  const effectiveCount =
    selectAll && totalCount
      ? totalCount - (uncheckList?.length || 0)
      : selectedRowKeys.length;

  return (
    <>
      {(selectAll || selectedRowKeys.length > 0) && (
        <>
          {/* <Button onClick={() => setSuggestModalOpen(true)}>
            Suggest in a campaign ({selectedRowKeys.length})
          </Button>
          <Button onClick={() => setIsSuggestInfluencerPricingModalOpen(true)}>
            Copy Influencers ({selectedRowKeys.length})
          </Button> */}
          <Dropdown
            trigger={["click"]}
            menu={{
              items: [
                {
                  label: (
                    // <DisabledPopover
                    //   content="You can add up to 100 influencers to a bucket"
                    //   isDisabled={selectedRowKeys.length <= 100}
                    // >
                    <span>Add to Bucket ({effectiveCount})</span>
                    // </DisabledPopover>
                  ),
                  key: "add-to-bucket",
                  // disabled: selectedRowKeys.length > 100,
                  onClick: () => setBucketModalVissible(true),
                },
                {
                  label: (
                    <span>Add to Campaign ({effectiveCount})</span>
                  ),
                  key: "add-to-campaign",
                  onClick: () => setOpenAddToCampaignProps({ open: true }),
                },
              ],
            }}
          >
            <Button icon={<MoreOutlined />} />
          </Dropdown>
          <AddCustomFieldsDataButton
            selectAll={selectAll}
            checkedList={selectedRowKeys as string[]}
            uncheckList={uncheckList}
            searchPayload={params || {}}
            totalCount={totalCount || selectedRowKeys.length}
            onSuccess={updateBriefInfluencers}
            visibleColumns={visibleCustomFields}
          />
          <Dropdown
            trigger={["click"]}
            placement="bottomRight"
            menu={{
              items: [
                ...[
                  {
                    label: "Send for Pricing",
                    key: "assign-pricing-poc",
                    onClick: () => {
                      openPricingPocModal(
                        selectedRowKeys as string[],
                        "assign"
                      );
                    },
                  },
                ],
                ...(isReAssginOrRemoveVisible
                  ? [
                      {
                        label: "Reallocate Pricing POC",
                        key: "reassign-pricing-poc",
                        onClick: () => {
                          openPricingPocModal(
                            selectedRowKeys as string[],
                            "reassign"
                          );
                        },
                      },
                      {
                        label: "Remove Pricing POC",
                        key: "remove-pricing-poc",
                        onClick: () => {
                          openPricingPocModal(
                            selectedRowKeys as string[],
                            "remove"
                          );
                        },
                      },
                    ]
                  : []),
              ],
            }}
          >
            <Button
              icon={<UpOutlined size={16} />}
              iconPosition="end"
              type="primary"
            >
              Pricing Actions
            </Button>
          </Dropdown>

          <Button
            type="primary"
            loading={isBulkActions}
            onClick={handleResendConfirmation}
          >
            Resend Confirmation ({effectiveCount})
          </Button>

          <Button
            type="primary"
            loading={isBulkActions}
            onClick={handleSkipConfirmation}
          >
            Skip Confirmation ({effectiveCount})
          </Button>
        </>
      )}

      <Modal
        destroyOnClose
        title={"Suggest selected influencers in a campaign"}
        open={isSuggestModalOpen}
        onCancel={() => {
          setSuggestModalOpen(false);
        }}
        footer={null}
        width={1000}
      >
        <SuggestCampaignFromBriefForm
          creators={selectedRows || []}
          onClose={() => {
            setSelectedRows([]);
            setSelectedRowKeys([]);
            setSuggestModalOpen(false);
          }}
        />
      </Modal>
      <Modal
        destroyOnClose
        title={"Copy selected influencers in a campaign"}
        open={isSuggestInfluencerPricingModalOpen}
        onCancel={() => {
          setIsSuggestInfluencerPricingModalOpen(false);
        }}
        footer={null}
        width={1000}
      >
        <SuggestInfluencerPricingForm
          briefInfluencerIds={selectedRowKeys.map((key) => key as string) || []}
          handleSuccess={() => {
            setSelectedRowKeys([]);
            setIsSuggestInfluencerPricingModalOpen(false);
            setSelectedRows([]);
          }}
          onClose={() => {
            setIsSuggestInfluencerPricingModalOpen(false);
          }}
        />
      </Modal>
      <Modal
        title="Add Influencer To Bucket"
        open={isBucketModalVisible}
        onCancel={() => setBucketModalVissible(false)}
        footer={
          <>
            <Divider style={{ margin: "8px 0" }} />
            <Space
              style={{
                padding: "0 8px 4px",
                width: "100%",
                justifyContent: "space-between",
              }}
            ></Space>
            {bucketId ? (
              <Row style={{ justifyContent: "center", padding: 10 }}>
                {isBulkActions ? (
                  <Spin style={{ width: 30, height: 30 }} />
                ) : (
                  <Button
                    onClick={async () => handleAdd(bucketId)}
                    icon={<PlusOutlined />}
                  >
                    Add to selected bucket
                  </Button>
                )}
              </Row>
            ) : null}
          </>
        }
        destroyOnClose
      >
        <AddToBucket
          bucketIds={[bucketId]}
          setselectedbuckedIds={(val) => setselectedbuckedId(typeof(val) === "string" ? val : val?.[0])}
        />
      </Modal>

      <AddToCampaignFromBrief
        briefId={briefId}
        isInAll={false}
        onClose={() => {
          setOpenAddToCampaignProps({ open: false });
        }}
        open={openAddToCampaignProps.open}
        selectedBriefInfluencers={selectedRowKeys as string[]}
        selectAll={selectAll || false}
        checkedList={selectedRowKeys as string[]}
        totalCount={totalCount || selectedRowKeys.length}
        uncheckList={uncheckList || []}
        searchPayload={params || {}}
      />

      <Modal
        open={pricingPocModalProps.visible}
        onCancel={() =>
          setPricingPocModalProps({
            visible: false,
            briefInfluencerId: [],
            type: "assign",
          })
        }
        footer={null}
        title={
          pricingPocModalProps.type === "assign"
            ? "Assign Pricing POC"
            : pricingPocModalProps.type === "reassign"
              ? "Reallocate Pricing POC"
              : "Remove Pricing POC"
        }
        destroyOnClose
        width={700}
      >
        {pricingPocModalProps.visible && (
          <AssignPricingModalV2
            briefInfluencerIds={pricingPocModalProps.briefInfluencerId}
            type={pricingPocModalProps.type}
            selectAll={selectAll}
            uncheckList={uncheckList}
            totalCount={totalCount}
            onClose={() =>
              setPricingPocModalProps({
                visible: false,
                briefInfluencerId: [],
                type: "assign",
              })
            }
            isLoading={isBulkActions}
            onConfirm={(data) => {
              if (pricingPocModalProps.type === "assign") {
                bulkActions({
                  briefId,
                  actionType: BriefNotificationActionType.assignPricingPoc,
                  ids: selectedRowKeys as string[],
                  notIncludeIds: uncheckList,
                  isSelectAll: selectAll,
                  filterParams: params || {},
                  actionParams: {
                    assignPricingPocParams: {
                      assignedToUserId: data.assignedToUserId,
                      briefId,
                      deadlineFrom: data.deadlineFrom,
                      deadlineTo: data.deadlineTo,
                      pricingOutreachTerms: data.pricingOutreachTerms,
                    },
                  },
                });
              } else if (pricingPocModalProps.type === "reassign") {
                bulkActions({
                  briefId,
                  actionType: BriefNotificationActionType.reallocatePricingPoc,
                  ids: selectedRowKeys as string[],
                  notIncludeIds: uncheckList,
                  isSelectAll: selectAll,
                  filterParams: params || {},
                  actionParams: {
                    reallocatePricingPocParams: {
                      reallocatedToUserId: data.assignedToUserId,
                      briefId,
                      deadlineFrom: data.deadlineFrom,
                      deadlineTo: data.deadlineTo,
                      pricingOutreachTerms: data.pricingOutreachTerms,
                    },
                  },
                });
              } else {
                bulkActions({
                  briefId,
                  actionType: BriefNotificationActionType.removePricingPoc,
                  ids: selectedRowKeys as string[],
                  notIncludeIds: uncheckList,
                  isSelectAll: selectAll,
                  filterParams: params || {},
                  actionParams: {
                    removePricingPocParams: {
                      briefId,
                    },
                  },
                });
              }
            }}
          />
        )}
      </Modal>
    </>
  );
}
